import questionFilter from './src'
questionFilter.install = (Vue) => {
  Vue.component(questionFilter.name, questionFilter)
}
export default questionFilter



// WEBPACK FOOTER //
// ./packages/question-filter/index.js